import { useQuery } from '@tanstack/react-query';
import { IDialogLegalTransactionTypeMapping } from '../../Interfaces/IDialogLegalTransactionTypeMapping';
import { customFetcher } from '../useFetch';

export const useGetDialogMappings = () => {
  const { data: dialogMappings, isLoading: isLoadingDialogMappings } = useQuery<
    IDialogLegalTransactionTypeMapping[]
  >({
    queryKey: ['dialoglegaltransactiontypemapping'],
    queryFn: () =>
      customFetcher({
        endpoint: '/dialoglegaltransactiontypemapping',
      }),
  });

  return { dialogMappings, isLoadingDialogMappings };
};
